'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _range = require('lodash/range');

var _range2 = _interopRequireDefault(_range);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ratings snap to 0.5
var SNAP = 0.5;

// Rounds a rating to the nearest snap point.
var roundToNearest = function roundToNearest(rating) {
  return Math.round(rating / SNAP) * SNAP;
};

/**
 * A single star.
 */
var Star = function Star(_ref) {
  var filled = _ref.filled,
      size = _ref.size,
      half = _ref.half,
      other = (0, _objectWithoutProperties3.default)(_ref, ['filled', 'size', 'half']);

  var icon = 'star';
  if (half) {
    icon += '-half-o';
  } else if (!filled) {
    icon += '-o';
  }

  return _react2.default.createElement(
    'span',
    other,
    _react2.default.createElement(_Icon2.default, { name: icon, size: size, className: 'Rating__star' })
  );
};

Star.propTypes = {
  filled: _propTypes2.default.bool,
  half: _propTypes2.default.bool,
  size: _propTypes2.default.number
};

/**
 * Rating component. Nice!
 */

var Rating = function (_Component) {
  (0, _inherits3.default)(Rating, _Component);

  function Rating() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Rating);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Rating.__proto__ || (0, _getPrototypeOf2.default)(Rating)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { hoveredRating: null }, _this.mouseEnter = function (ratingNumber) {
      if (_this.props.readonly) return;
      _this.setState({ hoveredRating: ratingNumber });
    }, _this.mouseLeave = function () {
      if (_this.props.readonly) return;
      _this.setState({ hoveredRating: null });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /**
   * Initially we are not hovering.
   */


  /**
   * Used to track the rating we are hovering on.
   *
   * @param  {Number} ratingNumber
   * The rating we are hovering on.
   */


  /**
   * Used to reset the hover state.
   */


  (0, _createClass3.default)(Rating, [{
    key: 'render',


    /**
     * Duh.
     */
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          rating = _props.rating,
          maxRating = _props.maxRating,
          onRatingClick = _props.onRatingClick,
          readonly = _props.readonly,
          starSize = _props.starSize,
          style = _props.style,
          color = _props.color,
          rest = (0, _objectWithoutProperties3.default)(_props, ['className', 'rating', 'maxRating', 'onRatingClick', 'readonly', 'starSize', 'style', 'color']);
      // When hovering, the rating displayed is that under the cursor.

      var usedRating = roundToNearest(this.state.hoveredRating === null || readonly ? rating : this.state.hoveredRating);

      // We ceil the rating so we know if it's a whole number or not when iterating.
      var ratingCeil = Math.ceil(usedRating);

      // Util to create props for each star.
      var createProps = function createProps(i) {
        return {
          // Click event will only trigger if not readonly.
          onClick: function onClick(e) {
            return !readonly && onRatingClick && onRatingClick(e, i);
          },
          // Used to set hover state.
          onMouseEnter: function onMouseEnter() {
            return _this2.mouseEnter(i);
          },
          // Used to reset hover state.
          onMouseLeave: _this2.mouseLeave,
          // Size of the star
          size: starSize,
          className: 'star',
          key: i
        };
      };

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          className: (0, _classnames2.default)('Rating', readonly && 'Rating--readonly', className),
          style: (0, _extends3.default)({
            color: color
          }, style)
        }, rest),
        (0, _range2.default)(1, ratingCeil + 1).map(function (i) {
          return _react2.default.createElement(Star, (0, _extends3.default)({}, createProps(i), {
            filled: true
            // It'll be half a star when the rating we have is less than the ceil of it.
            , half: i === ratingCeil && ratingCeil > usedRating
          }));
        }),
        (0, _range2.default)(ratingCeil + 1, maxRating + 1).map(function (i) {
          return _react2.default.createElement(Star, createProps(i));
        })
      );
    }
  }]);
  return Rating;
}(_react.Component);

exports.default = Rating;


Rating.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  starSize: _propTypes2.default.number,
  maxRating: _propTypes2.default.number,
  rating: _propTypes2.default.number.isRequired,
  onRatingClick: _propTypes2.default.func,
  readonly: _propTypes2.default.bool
};

Rating.defaultProps = {
  color: '#FFEB3B',
  starSize: 24,
  maxRating: 5,
  rating: 0,
  readonly: false
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Rating/index.js
// module id = 622
// module chunks = 0